import { CROP_HEIGHT, CROP_WIDTH } from '../_shared/ImageConstant'

// 四捨五入到小數第二位
const roundedRatio = (ratio) => {
  return Math.round((ratio + Number.EPSILON) * 100) / 100
}

const cropPositionCalculator = ({ position, originalSize, bgImageSize, cropSize }) => {
  if (position === '50%') {
    const actualPosition = (bgImageSize - cropSize) / 2
    return Math.abs(Math.floor((actualPosition * originalSize) / bgImageSize))
  } else {
    return Math.abs(Math.floor((-position * originalSize) / bgImageSize))
  }
}

const apiCropSizeCalculator = ({ originalHeight, originalWidth, cropHeight, cropWidth }) => {
  let apiCropHeight = 0
  let apiCropWidth = 0

  const originalImageRatio = roundedRatio(originalHeight / originalWidth)
  const cropRatio = roundedRatio(cropHeight / cropWidth)
  if (originalImageRatio > cropRatio) {
    // 比較長，上下移動
    apiCropWidth = originalWidth
    apiCropHeight = Math.floor(originalWidth / (CROP_WIDTH / CROP_HEIGHT))
  } else if (originalImageRatio === cropRatio) {
    // 比例一樣，無法移動
    apiCropWidth = originalWidth
    apiCropHeight = originalHeight
  } else {
    // 比較扁，左右移動
    apiCropHeight = originalHeight
    apiCropWidth = Math.floor((originalHeight * CROP_WIDTH) / CROP_HEIGHT)
  }
  return { apiCropHeight, apiCropWidth }
}

const bgImageSizeCalculator = (originalWidth, originalHeight) => {
  const result = {
    width: 0,
    height: 0,
  }
  const originalImageRatio = roundedRatio(originalHeight / originalWidth)
  const cropRatio = roundedRatio(CROP_HEIGHT / CROP_WIDTH)

  if (originalImageRatio > cropRatio) {
    // 比較長，上下移動
    result.width = CROP_WIDTH
    result.height = Math.floor((originalHeight * CROP_WIDTH) / originalWidth)
  } else if (originalImageRatio === cropRatio) {
    // 比例一樣，無法移動
    result.width = CROP_WIDTH
    result.height = CROP_HEIGHT
  } else {
    // 比較扁，左右移動
    result.width = Math.floor((originalWidth * CROP_HEIGHT) / originalHeight)
    result.height = CROP_HEIGHT
  }

  return result
}

type CalculateCropParametersInput = {
  cropPosition?: any
  originalWidth?: number
  originalHeight?: number
  bgImageWidth?: number
  bgImageHeight?: number
  cropWidth?: number
  cropHeight?: number
}

export const getCropParameters = (input: CalculateCropParametersInput) => {
  const bgImageSize = bgImageSizeCalculator(input.originalWidth, input.originalHeight)
  const apiCropSize = apiCropSizeCalculator({
    originalHeight: input.originalHeight,
    originalWidth: input.originalWidth,
    cropHeight: input.cropHeight,
    cropWidth: input.cropWidth,
  })
  const apiCropWidth = apiCropSize.apiCropWidth
  const apiCropHeight = apiCropSize.apiCropHeight

  const result = {
    x: cropPositionCalculator({
      position: input.cropPosition.croppedBgPositionX,
      originalSize: input.originalWidth,
      bgImageSize: bgImageSize.width,
      cropSize: CROP_WIDTH,
    }),
    y: cropPositionCalculator({
      position: input.cropPosition.croppedBgPositionY,
      originalSize: input.originalHeight,
      bgImageSize: bgImageSize.height,
      cropSize: CROP_HEIGHT,
    }),
    width: apiCropWidth,
    height: apiCropHeight,
  }
  return result
}
